import { render, staticRenderFns } from "./session_summary.vue?vue&type=template&id=3b6b373e&"
import script from "./session_summary.vue?vue&type=script&lang=js&"
export * from "./session_summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b6b373e')) {
      api.createRecord('3b6b373e', component.options)
    } else {
      api.reload('3b6b373e', component.options)
    }
    module.hot.accept("./session_summary.vue?vue&type=template&id=3b6b373e&", function () {
      api.rerender('3b6b373e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/sessions/session_summary.vue"
export default component.exports